import * as invoiceService from '@features/invoices/services/invoiceService';
import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from "@tanstack/react-query";

export function useInvoices(isAdmin, params) {
  const queryClient = useQueryClient();

  const { data: invoices, isLoading, error } = useQuery({
    queryKey: ["invoices", params],
    queryFn: () => invoiceService.fetchAllInvoice(isAdmin, params),
  });

  const createMutation = useMutation({
    mutationFn: invoiceService.createInvoice,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
      queryClient.invalidateQueries({ queryKey: ["packagesInvoices"] });
    },
    onError: (error) => {
      console.error("Invoice creation error:", error);
    },
  });

  const deleteMutation = useMutation({
    mutationFn: invoiceService.deleteInvoice,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
      queryClient.invalidateQueries({ queryKey: ["packagesInvoices"] });
    },
    onError: (error) => {
      console.error("Invoice deletion error:", error);
    },
  });

  return {
    invoices,
    isLoading,
    error,
    createInvoice: createMutation.mutate,
    createInvoiceLoading: createMutation.isPending,
    createInvoiceError: createMutation.error,
    deleteInvoice: deleteMutation.mutate,
    deleteInvoiceLoading: deleteMutation.isPending,
    deleteInvoiceError: deleteMutation.error,
  };
}

export const useInvoicesInfiniteQuery = (params) => {
  const searchParams = new URLSearchParams(params);
  return useInfiniteQuery({
    queryKey: ["invoices", params],
    queryFn: async ({ pageParam }) => {
      return invoiceService.fetchAllInvoice(
        `page=${pageParam}&${searchParams.toString()}`
      );
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.pageInfo.nextPage !== null
        ? lastPage.pageInfo.nextPage
        : undefined;
    },
  });
};
